export default __webpack_public_path__ + "static/media/0x72bd80445b0db58ebe3e8db056529d4c5faf6f2f.4a39ede7.webp";